import { Component } from "@angular/core";

import {ReservationService} from "../../../service/reservation/reservation.service";
import {RoomReservation, Room} from "../../../service/reservation/reservation";

import {ActivatedRoute} from "@angular/router";
import { Member, Credit } from "app/service/member/member";
import { ShareService } from "app/service/share/share.service";
import * as moment from 'moment';

@Component({
  selector: 'app-reservation-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  providers: [ShareService, ReservationService]
})
export class ReservationListComponent{
  location: string;
  me: Member;
  credit: Credit;

  startTimeIndex = {};
  startTimes: string[] = ['0800', '0830', '0900', '0930', '1000', '1030', '1100', '1130', '1200', '1230', '1300', '1330',
    '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030',
    '2100', '2130', '2200', '2230', '2300', '2330'];

  roomTimes: string[] = ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
    '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'];


  category: string;
  date: string;
  constructor(private shareService: ShareService,
              private reservationService: ReservationService,
              private route: ActivatedRoute) {

    this.startTimes.forEach((value, index) => this.startTimeIndex[value] = index);

    this.route.params.subscribe(
      params => {

        this.category = params['category'];
        this.date     = params['date'];

        this.shareService.awaitMe().take(1).subscribe(
          me => {
            this.me = me;
            this.location = me.location.key

            this.getReservations();
          }
        )
      }
    )

    this.shareService.awaitCredit().take(1).subscribe(
      credit => this.credit = credit
    )
  }

  rooms: Room[];
  private getReservations() {
    if(this.category === 'rooms') {
      this.reservationService.getRooms(this.location, this.date).take(1).subscribe(
        rooms => {
          this.rooms = rooms

          this.reservationService.getMyReservationsRooms(this.location).take(1).subscribe(
            reservations => this.makeTable(reservations)
          )
        }
      )

    }
    else if(this.category === 'spaces') {
      this.reservationService.getSpaces(this.date).take(1).subscribe(
        rooms => {
          this.rooms = rooms

          this.reservationService.getMyReservationsSpaces().take(1).subscribe(
            reservations => this.makeTable(reservations)
          )
        }
      )
    }
  }

  reservations: RoomReservation[] = [];
  makeTable(reservations) {
    this.tablePage = 1;
    this.reservations = reservations;

    // console.log(reservations)
  }

  tablePage: number = 1;
  tableSize: number = 10;
  get myReservations(): RoomReservation[] {
    return this.reservations
      .slice((this.tablePage - 1) * this.tableSize, this.tablePage * this.tableSize);
  }
  onChangePage(page) {
    this.tablePage = page.page
  }

  getRoomName(nm, floor, size): string {
    return `${nm} (${Number(floor)}층 ${size}인실)`;
  }
  getLocationName(room) {
    return room.pblspc_cd.indexOf('S111') === 0 ? '성수 시작점' : '서울숲점'
  }
  getRoomNameBycd({pblspc_nm, pblspc_cd}): string {
    let rooms = this.rooms ? this.rooms : []
    let room = rooms.find(o=>o.cd === pblspc_cd)
    if(room)
      return `${room.nm} (${Number(room.floor)}층 ${room.bsc_num}인실)`;
    else
      return `${pblspc_nm}`
  }

  onBack() {
    history.back();
  }

  onClickTableCancel(reservation) {
    let typeTxt = this.category === 'rooms' ? '회의실' : '대관장소'
    let result = window.confirm(`${typeTxt} 예약을 취소합니다.`);

    if(result) {
      this.reservationService.cancel(reservation.cd).subscribe(
        res => {
          this.getReservations();
          this.shareService.refreshCredit();
        },
        error => {
          window.alert(`${typeTxt} 예약을 취소할 수 없습니다.`);
        }
      );
    }
  }

  convDe_use(de_use){
    return moment(de_use, 'YYYYMMDD').format('YYYY-MM-DD')
  }
}


// WEBPACK FOOTER //
// ./src/app/member/reservation/list/list.component.ts